import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { AnimationCommon } from 'components/common';
import Navbar from './Navbar';

const RootLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const params = new URLSearchParams(window.location.search);
  const isPreviewMode = params.get('preview') === 'true';
  const location = useLocation();

  return (
    <div className={'flex flex-col min-h-screen w-full' + (isPreviewMode ? ' p-8 ' : ' ')}>
      {!isPreviewMode && <Navbar />}

      <AnimatePresence mode='wait'>
        <AnimationCommon
          key={location.pathname}
          effect='fadeDown'
          transition='medium'
          duration={0.4}
          delay={0.2}
          disablePresence={true}
          className={
            'flex-grow w-full h-full ' +
            (isPreviewMode ? 'rounded-3xl bg-[var(--bgGreyColor3)] ' : 'bg-[var(--bgGreyColor2)] ')
          }
          fullWidth
          fullHeight
          role='main'
        >
          <Outlet />
          {children}
        </AnimationCommon>
      </AnimatePresence>
    </div>
  );
};

export { RootLayout };
